import { useMemo } from 'react';

export const useObjectData = () => {
  return useMemo(() => {
    try {
      const objectDataStr = localStorage.getItem('objectData');
      return objectDataStr ? JSON.parse(objectDataStr) : [];
    } catch (error) {
      console.error('Error parsing objectData from localStorage:', error);
      return [];
    }
  }, []);
};

export const useEnumData = () => {
  return useMemo(() => {
    try {
      const enumDataStr = localStorage.getItem('enumData');
      return enumDataStr ? JSON.parse(enumDataStr) : [];
    } catch (error) {
      console.error('Error parsing enumData from localStorage:', error);
      return [];
    }
  }, []);
};

export const useLocalStorageData = (key, defaultValue = []) => {
  return useMemo(() => {
    try {
      const dataStr = localStorage.getItem(key);
      return dataStr ? JSON.parse(dataStr) : defaultValue;
    } catch (error) {
      console.error(`Error parsing ${key} from localStorage:`, error);
      return defaultValue;
    }
  }, [key, defaultValue]);
};
